import { clone } from '@jack-henry/frontend-utils/functions';
import { CountryModelDto } from '@treasury/api/channel';
import { DomainEntity } from '../shared';

export const nullWireCountry: CountryModelDto = {
    id: 0,
    countryName: '',
    countryCode: '',
    currencyName: '',
    currencyCode: '',
    intradaySpot: false,
};

export class WireCountry extends DomainEntity<CountryModelDto> {
    constructor(dto = clone(nullWireCountry)) {
        super(dto);
    }

    public createDefault(): this {
        return new WireCountry(clone(nullWireCountry)) as this;
    }

    public get countryName() {
        return this.dto.countryName || '';
    }

    public get countryCode() {
        return this.dto.countryCode || '';
    }

    public get currencyName() {
        return this.dto.currencyName || '';
    }

    public get currencyCode() {
        return this.dto.currencyCode || '';
    }

    public get intradaySpot() {
        return this.dto.intradaySpot;
    }
}
